import VSelectVoucherType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectVoucherType', VSelectVoucherType),
};
